<div class="ui container charts-container">
    <div class="left-column">
        <div class="chart-container">
            <div class="chart-header">
                <h3>Successful Requests vs. Rate-Limited Requests</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Rate Limit Geofence Violations</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Requests Rates</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
    </div>
    <div class="right-column">
        <div class="chart-container">
            <div class="chart-header">
                <h3>Rate Limit Error Frequency</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
        <div class="chart-container">
            <div class="chart-header">
                <h3>Rate Limit Hit</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        
    </div>
</div>